import type { GetChatThreadById200CurrentUserStatusStatus } from './getChatThreadById200CurrentUserStatusStatus';

export type GetChatThreadById200CurrentUserStatus = {
  /** @nullable */
  acceptedAt?: string | null;
  /** @nullable */
  invitedBy?: string | null;
  /** @nullable */
  requestedAt?: string | null;
  status: GetChatThreadById200CurrentUserStatusStatus;
};
